/** @jsx jsx */
import React from "react";
import { useNavigate } from "react-router-dom";
import { css, jsx } from "@emotion/react";
import {
  Container,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import TodayIcon from "@mui/icons-material/Today";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

export default function PrimaryOfferings() {
  const navigate = useNavigate();
  const offeringPlans = [
    {
      title: "Daily Plan",
      description:
        "Perfect for those who prefer day-to-day flexibility. Choose services as needed without commitment.",
      icon: <TodayIcon sx={{ fontSize: 50, color: "primary.main" }} />,
      action: "Explore Daily",
      tag: "Daily",
    },
    {
      title: "Weekly Plan",
      description:
        "Ideal for regular needs with a weekly schedule. Save more with our weekly subscription packages.",
      icon: <ViewWeekIcon sx={{ fontSize: 50, color: "primary.main" }} />,
      action: "Explore Weekly",
      tag: "Weekly",
    },
    {
      title: "Monthly Plan",
      description:
        "Our best value option for consistent needs. Maximum savings with monthly subscription plans.",
      icon: <CalendarMonthIcon sx={{ fontSize: 50, color: "primary.main" }} />,
      action: "Explore Monthly",
      tag: "Monthly",
    },
  ];

  const handlePlanClick = (tag) => {
    // console.log(`Selected plan: ${planType}`);
    navigate("ProductLIst/NA/NA/" + tag);
    // Add navigation or other functionality here
  };

  return (
    <React.Fragment>
      <Container maxWidth="xl">
        <Box sx={{ position: "relative", py: 6, px: 2, textAlign: "center" }}>
          <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
            Explore Serving Plans
          </Typography>
          <Box
            sx={{
              width: "80px",
              height: "2px",
              backgroundColor: "primary.main",
              mx: "auto",
              mb: 4,
            }}
          />

          <Grid container spacing={4} justifyContent="center">
            {offeringPlans.map((plan, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    height: "100%",
                    transition: "transform 0.3s ease-in-out",
                    borderRadius: "12px",
                    cursor: "pointer",
                    boxShadow: 3,
                    "&:hover": {
                      transform: "translateY(-10px)",
                      boxShadow: 6,
                    },
                  }}
                  onClick={() => handlePlanClick(plan.tag)}
                >
                  <CardContent sx={{ p: 4, textAlign: "center" }}>
                    <Box sx={{ mb: 2 }}>{plan.icon}</Box>
                    <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                      {plan.title}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      {plan.description}
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ borderRadius: "25px", px: 3 }}
                    >
                      {plan.action}
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </React.Fragment>
  );
}
